export const nilObjectID = "000000000000000000000000";